/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarningFill = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18" {...props}>
    <path
      fill="#D7A114"
      d="M19.052 15.707 11.063.87c-.566-1.052-2.075-1.052-2.641 0L.433 15.707a1.5 1.5 0 0 0 1.319 2.211H17.73a1.5 1.5 0 0 0 1.32-2.211Zm-9.31-.086a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875Zm1.019-9.429-.27 5.719a.75.75 0 1 1-1.5 0l-.268-5.716A1.019 1.019 0 0 1 9.73 5.13h.01a1.019 1.019 0 0 1 1.019 1.064l.002-.003Z"
    />
  </svg>
);

export default SvgWarningFill;
